import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { useAppContextSelector, usePrevious } from 'hooks';
import { Routes } from 'types';
import { DEV_FEATURES } from '__dev';

export const RouterRedirectManager = () => {
  const { accessToken, complete } = useAppContextSelector((ctx) => ctx.state);
  const { pathname } = useLocation();
  const prevPathname = usePrevious(pathname);

  const preAuthRoutes = [Routes.init, Routes.verify, Routes.sessionExpired];
  const authRoutes = [
    Routes.main,
    Routes.connect,
    Routes.upload,
    Routes.acceptance,
    Routes.acceptanceConfirmation,
    Routes.achGreenIdVerification,
    Routes.achConsents,
    Routes.achSubmitted,
    Routes.achDocUpload,
    Routes.nzAmlConsents,
    Routes.nzAmlDocUpload,
    Routes.amlNzSubmitted,
    Routes.assistedApply,
    Routes.pendingCustomerAcceptance,
    Routes.assistedApplyReferred,
    Routes.assistedApplyClaimError,
    Routes.sessionExpired
  ];
  const completeRoutes = [Routes.outcome, Routes.sessionExpired, Routes.achSubmitted, Routes.amlNzSubmitted, Routes.assistedApplyReferred, Routes.pendingCustomerAcceptance];

  const accessibleRoutes = complete ? completeRoutes : accessToken ? authRoutes : preAuthRoutes;

  if (
    DEV_FEATURES.ALLOW_NAVIGATION_TO_ALL_ROUTES ||
    pathname === prevPathname ||
    accessibleRoutes.includes(pathname as Routes)
  ) {
    return null;
  }

  const redirectPath = prevPathname ? prevPathname : !accessToken ? Routes.init : Routes.main;

  return <Redirect to={redirectPath} />;
};
